import React from "react";

const NotFoundPage = () => {
  return <h1>404...This page is not found!</h1>;
};

export default NotFoundPage;
